import React from 'react';
import classNames from 'classnames';
import { Tag as TagAntd } from 'antd';
import type { TagProps } from './types';
import './Tag.scss';

export const Tag: React.FC<TagProps> = ({ className, ...props }) => (
  <TagAntd className={classNames('tag-default', className)} {...props} />
);
